import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "text-gray-600 text-sm font-normal" }

import LingoBadge from './LingoBadgeComponent.vue';

interface DataItem {
  label: string;
  value: string;
  color?: string | any;
}

interface Props {
  items: DataItem[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LingoDataItemComponent',
  props: {
    items: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "flex justify-between items-center py-1 border-b border-gray-100 last:border-b-0"
      }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(item.label), 1),
        _createVNode(LingoBadge, {
          label: item.value,
          variant: "badge",
          tone: "outline",
          size: "sm",
          color: item.color || 'purple',
          icon: "none",
          "data-testid": `badge-${item.label.toLowerCase().replace(/\s+/g, '-')}`
        }, null, 8, ["label", "color", "data-testid"])
      ]))
    }), 128))
  ]))
}
}

})